import { apiRequest } from '../axios/httpServiceHandler';

export const getDetail = async (params) => {
    return await apiRequest({
        url: '/api/residential-mt/spacePrivacyVersion/getPrivacy',
        method: 'post',
        data: params
    });
}